/* src/app/modules/subscription/plan-change-preview/plan-change-preview.component.css */
:host {
  display: block;
}
.preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 7px 0;
  font-size: 0.92rem;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}
.preview-row:last-child {
  border-bottom: none;
}
.preview-row--total {
  margin-top: 4px;
  padding-top: 12px;
}
.preview-label {
  color: #64748b;
}
.preview-value {
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}
.preview-value--total {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--cf-brand-dark);
}
.preview-value--muted {
  color: #94a3b8;
  font-weight: 500;
}
/*# sourceMappingURL=plan-change-preview.component.css.map */
